export default "/images/mouse-pointer.svg?f5aba533dd5abee8715c550b566efc65";